import React from 'react';

type UserNetworkMonitoringProps = {};

const UserNetworkMonitoring = (props: UserNetworkMonitoringProps) => {
  return <div>UserNetworkMonitoring</div>;
};

export default UserNetworkMonitoring;
